import AboutPageSection from "../../Components/AboutSections/AboutPageSection";
import PageBanner from "../../layout/Banner";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import CallToAction from "../../layout/CTA";
import { Helmet } from "react-helmet-async";

const AboutPage = () => {
  return (
    <>
      <Helmet>
        <title>About R & P Law Partners | Law Firm in Delhi NCR</title>

        <meta
          name="description"
          content="Discover R & P Law Partners, a trusted law firm serving Delhi NCR with strategic legal solutions, experienced advocates, and client-focused representation."
        />

        <meta name="keywords" content="About" />

        <link rel="canonical" href="https://rplawpartners.com/about-us" />
      </Helmet>
      <Header />
      <PageBanner title="About Us" subtitle="Get to know us" />
      <AboutPageSection />
      <CallToAction />
      <Footer />
    </>
  );
};

export default AboutPage;
